<template>
  <div class="loader" v-if="isLoading">
    <div class="loader-graphic">
      <svg class="score-spinner" xmlns="http://www.w3.org/2000/svg"
        width="240" height="240" viewBox="0 0 240 240" version="1.1">
        <title>Loading</title>
        <g>
          <path class="inner" d="M202.835 89.368C198.193 76.923 190.826
            65.821 181.469 56.778 165.239 41.098 143.025 31.598 118.68 32.013
            110.565 32.153 104.094 38.847 104.234 46.962 104.374 55.077 111.063
            61.543 119.178 61.409 135.413 61.134 150.228 67.46 161.044 77.914
            171.861 88.372 178.69 102.959 178.965 119.189L178.968 119.189C178.979
            119.856 178.979 120.526 178.967 121.198 178.833 129.313 185.299 136.002
            193.414 136.142 201.529 136.282 208.223 129.811 208.363 121.696 208.557
            110.324 206.587 99.417 202.835 89.368L202.835 89.368Z"></path>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
/**
 * An animated loading spinner.
 *
 */
export default {
  name: 'Spinner',
  props: {
    isLoading: Boolean,
  },
};
</script>
